// Vuex -> pinia Migration guide : https://pinia.vuejs.org/cookbook/migration-vuex.html#Restructuring-Modules-to-Stores
import { createPinia } from 'pinia'
const pinia = createPinia();

export default pinia;

